import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, from, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip Bearer token for endpoints that use API key authentication
    const shouldSkipBearerToken = req.url.includes('/CallRequest/patient-call-list') ||
                                   req.url.includes('/CallRequest/call-queue') ||
                                   (req.url.includes('/agent/') && req.url.includes('/has-pending-calls')) ||
                                   (req.method === 'DELETE' && req.url.includes('/api/agent/'));
    
    let cloned = req;
    if (!shouldSkipBearerToken) {
      const token = this.auth.getToken();
      cloned = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;
    }
    
    return next.handle(cloned).pipe(
      catchError((error: HttpErrorResponse) => {
        const isAuthEndpoint = req.url.includes('/auth/refresh') ||
                               req.url.includes('/auth/external-login') ||
                               req.url.includes('/auth/logout');
        const alreadyRetried = req.headers.has('X-Comforce-Auth-Retry');

        if (!shouldSkipBearerToken && !isAuthEndpoint && error.status === 401 && !alreadyRetried) {
          return from(this.auth.recoverAuthentication()).pipe(
            switchMap((ok) => {
              if (!ok) {
                this.auth.clearSession();
                this.router.navigateByUrl('/auth-required');
                return throwError(() => error);
              }

              const token = this.auth.getToken();
              const retryRequest = token
                ? req.clone({
                    setHeaders: {
                      Authorization: `Bearer ${token}`,
                      'X-Comforce-Auth-Retry': '1'
                    }
                  })
                : req.clone({ setHeaders: { 'X-Comforce-Auth-Retry': '1' } });

              return next.handle(retryRequest);
            })
          );
        }

        // Only handle auth errors for Bearer token requests
        if (!shouldSkipBearerToken && (error.status === 401 || error.status === 403)) {
          this.auth.clearSession();
          this.router.navigateByUrl('/auth-required');
        }
        return throwError(() => error);
      })
    );
  }
}

export const AuthInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: AuthInterceptor,
  multi: true
};





